<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 88px">
      <Loading></Loading>
    </div>
    <div v-else>
      <v-container class="Kanit px-5" grid-list-xs>
        <div style="text-align: center" class="py-2 mb-3">
          <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
        </div>
        <div class="text-center">
          <h2 style="color: #0c4d9d" class="mb-4">ลงทะเบียน</h2>
        </div>
        <div class="Kanit">
          <ValidationObserver
            ref="observer"
            v-slot="{ handleSubmit }"
            tag="form"
          >
            <form @submit.prevent="handleSubmit(checkFeyvery)">
              <div style="text-align: center">
                <ValidationProvider
                  :name="'รูป'"
                  :rules="'required'"
                  key="photoUrl"
                  v-slot="{ errors }"
                >
                  <div
                    style="
                      width: 140px;
                      height: 140px;
                      margin-left: auto;
                      margin-right: auto;
                    "
                  >
                    <upload-file
                      :errors="errors"
                      :height="130"
                      v-model="input.photourl"
                    ></upload-file>
                  </div>
                  <div
                    style="color: #ff5252; font-size: 12px; margin-bottom: 5px"
                    v-if="errors.length"
                  >
                    กรุณาอัพโหลดรูปประจำตัว
                  </div>
                </ValidationProvider>
              </div>
              <div
                @click.stop="gmapopen = true"
                style="
                  position: relative;
                  border: 1px solid #0c4d9d;
                  border-radius: 10px;
                  padding: 5px;
                "
              >
                <v-row>
                  <v-col class="pa-0 pl-2" cols="1">
                    <div
                      style="
                        position: absolute;
                        left: 6px;
                        top: 50%;
                        -ms-transform: translateY(-50%);
                        transform: translateY(-50%);
                      "
                    >
                      <v-icon style="font-size: 32px" color="red"
                        >mdi-map-marker</v-icon
                      >
                    </div>
                  </v-col>
                  <v-col class="pa-0 pl-4" cols="9">
                    <div style="color: #0c4d9d">เลือกพื้นที่</div>
                    <div style="color: darkgrey; font-size: smaller">
                      ใช้สำหรับเพิ่มความถูกต้องของที่อยู่
                    </div>
                  </v-col>
                </v-row>
                <div
                  style="
                    position: absolute;
                    right: 0;
                    top: 50%;
                    -ms-transform: translateY(-50%);
                    transform: translateY(-50%);
                  "
                >
                  <v-icon style="font-size: 42px" color="#0c4d9d"
                    >mdi-chevron-right</v-icon
                  >
                </div>
              </div>
              <template v-if="query.dealer == 'true'">
                <ValidationProvider
                  :name="'รหัสร้านค้า'"
                  :rules="'required'"
                  key="storeid"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    large
                    outlined
                    class="mt-4"
                    v-model="input.toa_shopid"
                    placeholder="รหัสร้านค้า"
                    :error-messages="errors"
                    :valid="valid"
                  ></v-text-field>
                </ValidationProvider>
                <ValidationProvider
                  :name="'ชื่อร้านค้า'"
                  :rules="'required'"
                  key="storename"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    large
                    outlined
                    @input="input.storename = removeHiddenSpace($event)"
                    v-model="input.storename"
                    placeholder="ชื่อร้านค้า"
                    :error-messages="errors"
                    :valid="valid"
                  ></v-text-field>
                </ValidationProvider>
                <ValidationProvider
                  :name="'ชื่อผู้ติดต่อ'"
                  :rules="'required'"
                  key="contact_name"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    large
                    outlined
                    @input="input.contact_name = removeHiddenSpace($event)"
                    v-model="input.contact_name"
                    placeholder="ชื่อผู้ติดต่อ"
                    :error-messages="errors"
                    :valid="valid"
                  ></v-text-field>
                </ValidationProvider>
                <ValidationProvider
                  :name="'อีเมล์'"
                  :rules="'required|email'"
                  key="email"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    large
                    outlined
                    @input="input.email = removeHiddenSpace($event)"
                    v-model="input.email"
                    placeholder="อีเมล์"
                    :error-messages="errors"
                    :valid="valid"
                  ></v-text-field>
                </ValidationProvider>

                <ValidationProvider
                  :name="'เบอร์โทรศัพท์'"
                  :rules="'required'"
                  key="phoneno"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    rows="4"
                    auto-grow
                    type="number"
                    outlined
                    name="phoneno"
                    v-model="input.phoneno"
                    placeholder="เบอร์โทรศัพท์"
                    :error-messages="errors"
                    :valid="valid"
                  ></v-text-field>
                </ValidationProvider>
              </template>
              <template v-else>
                <ValidationProvider
                  :name="'ชื่อจริง'"
                  :rules="'required'"
                  key="firstname"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    large
                    outlined
                    class="mt-4"
                    @input="input.firstname = removeHiddenSpace($event)"
                    v-model="input.firstname"
                    placeholder="ชื่อจริง"
                    :error-messages="errors"
                    :valid="valid"
                  ></v-text-field>
                </ValidationProvider>
                <ValidationProvider
                  :name="'นามสกุล'"
                  :rules="'required'"
                  key="lastname"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    outlined
                    name="lastname"
                    @input="input.lastname = removeHiddenSpace($event)"
                    v-model="input.lastname"
                    placeholder="นามสกุล"
                    :error-messages="errors"
                    :valid="valid"
                  ></v-text-field>
                </ValidationProvider>
                <ValidationProvider
                  :name="'เบอร์โทรศัพท์'"
                  :rules="'required'"
                  key="phoneno"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    rows="4"
                    auto-grow
                    type="number"
                    outlined
                    name="phoneno"
                    v-model="input.phoneno"
                    placeholder="เบอร์โทรศัพท์"
                    :error-messages="errors"
                    :valid="valid"
                  ></v-text-field>
                </ValidationProvider>
              </template>
              <ValidationProvider
                :name="'รหัสไปรษณีย์'"
                :rules="'required'"
                key="zipcode"
                v-slot="{ errors }"
              >
                <thai-address-input
                  v-model="input.postcode"
                  type="zipcode"
                  @select="onSelectAddress"
                  :placeholder="`รหัสไปรษณีย์`"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></thai-address-input>
              </ValidationProvider>
              <div style="clear: both"></div>
              <ValidationProvider
                :name="'จังหวัด'"
                :rules="'required'"
                key="province"
                v-slot="{ errors }"
              >
                <thai-address-input
                  v-model="input.province"
                  type="province"
                  :placeholder="`จังหวัด`"
                  @select="onSelectAddress"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></thai-address-input>
              </ValidationProvider>
              <div style="clear: both"></div>

              <ValidationProvider
                :name="'อำเภอ/เขต'"
                :rules="'required'"
                key="amphoe"
                v-slot="{ errors }"
              >
                <thai-address-input
                  v-model="input.amphoe"
                  type="amphoe"
                  :placeholder="`อำเภอ/เขต`"
                  @select="onSelectAddress"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></thai-address-input>
              </ValidationProvider>
              <div style="clear: both"></div>
              <ValidationProvider
                :name="'ตำบล/แขวง'"
                :rules="'required'"
                key="district"
                v-slot="{ errors }"
              >
                <thai-address-input
                  v-model="input.tambon"
                  type="district"
                  :placeholder="`ตำบล/แขวง`"
                  @select="onSelectAddress"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></thai-address-input>
              </ValidationProvider>
              <div style="clear: both"></div>

              <ValidationProvider
                :name="'ที่อยู่'"
                :rules="'required'"
                key="addressno"
                v-slot="{ errors }"
              >
                <v-textarea
                  v-model="input.address"
                  outlined
                  rows="3"
                  placeholder="รายละเอียดที่อยู่ บ้านเลขที่ หมู่บ้าน ถนน"
                  class="mb-6"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></v-textarea>
              </ValidationProvider>
              <template v-if="query.dealer != 'true'">
                <ValidationProvider
                  :name="'ประสบการณ์'"
                  :rules="'required'"
                  key="experience"
                  v-slot="{ errors, valid }"
                >
                  <v-textarea
                    rows="4"
                    auto-grow
                    outlined
                    name="experience"
                    @input="input.experience = removeHiddenSpace($event)"
                    v-model="input.experience"
                    placeholder="ประสบการณ์"
                    :error-messages="errors"
                    :valid="valid"
                  ></v-textarea>
                </ValidationProvider>
              </template>
              <template v-if="query.dealer == 'true'">
                <ValidationProvider
                  :name="'ToaSmart'"
                  :rules="'required'"
                  key="ToaSmart"
                  v-slot="{ errors, valid }"
                >
                  <div>เคยเข้าร่วมโครงการ Toa Smart หรือไม่?</div>
                  <v-radio-group
                    class="ma-0"
                    name="ToaSmart"
                    :valid="valid"
                    :error-messages="errors"
                    v-model="toasmart"
                    row
                  >
                    <v-radio :value="true">
                      <template v-slot:label>
                        <div>ใช่</div>
                      </template>
                    </v-radio>
                    <v-radio :value="false">
                      <template v-slot:label>
                        <div>ไม่</div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </ValidationProvider>
                <div v-if="toasmart" class="pl-4">
                  <v-checkbox
                    class="ma-0"
                    v-model="input.fillgood_status"
                    style="font-size: 20px"
                    name="Fill Good token"
                    label="เคยสมัคร FillGood หรือไม่?"
                    :value="true"
                  ></v-checkbox>
                  <v-checkbox
                    class="ma-0"
                    v-model="input.paysolution_status"
                    style="font-size: 20px"
                    name="Pay Solution"
                    label="เคยสมัคร Pay Solution หรือไม่?"
                    :value="true"
                  ></v-checkbox>
                </div>
              </template>
              <div class="text-center mt-2 mb-4">
                <v-btn
                  block
                  type="submit"
                  :loading="saveloading"
                  dark
                  color="#0c4d9d"
                  >ลงทะเบียน</v-btn
                >
              </div>
            </form>
          </ValidationObserver>
        </div>
      </v-container>
      <v-dialog fullscreen v-model="gmapopen">
        <v-card v-if="gmapopen">
          <gmap
            @close="gmapopen = false"
            @gmapaddress="gmapaddress"
            v-if="showmap"
          ></gmap>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import UploadFile from "@/components/UploadProfile";
import ThaiAddressInput from "@/components/ThaiAddressInput";
import Gmap from "./GmapToa.vue";
import Loading from "@/components/Loading.vue";
export default {
  data() {
    return {
      toasmart: "",
      saveloading: false,
      loading: true,
      gmapopen: false,
      showmap: false,
      input: {
        toa_shopid: "",
        contact_name: "",
        email: "",
        firstname: "",
        lastname: "",
        address: "",
        address2: "",
        postcode: "",
        amphoe: "",
        tambon: "",
        province: "",
        experience: "",
        photourl: "",
        storename: "",
        phoneno: "",
        fillgood_status: false,
        paysolution_status: false,
      },
    };
  },
  components: {
    Loading,
    UploadFile,
    ThaiAddressInput,
    Gmap,
  },
  async mounted() {
    await this.checkLoginStatus();
    await this.checkRegisterStatus();
    // await this.setDefault();
    this.loading = false;
    this.gmapScriptInit({ key: "AIzaSyDFzoslRQ_7g6w37IdtCY8WJQluhqtfKVU" });
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  methods: {
    removeReddot(e) {
      this.input.email = this.removeHiddenSpace(e);
    },
    checkRegisterStatus() {
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toacheckusersregister",
            {
              params: {
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: this.query.pageid,
              },
              headers: {
                AUTHORIZATION: "Bearer xxx xxx ",
              },
            }
          )
          .then((response) => {
            if (response.data.responsecode == 200) {
              if (response.data.data[0].status) {
                //เคยสมัคร
                this.query.view = "Agreement";
                resolve();
              } else {
                resolve();
              }
            }
          });
      });
    },
    setDefault() {
      return new Promise((resolve) => {
        var data = {};
        axios
          .get("https://communitybotbyzwizai.herokuapp.com/toadealerinfo", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: {
              userid: this.$store.state.userid,
              apptype: this.query.apptype,
              pageid: this.query.pageid,
            },
          })
          .then(async (response) => {
            // `${this.input.address},.${this.input.postcode},.อำเภอ${this.input.amphoe},.ตำบล${this.input.tambon},.จังหวัด${this.input.province}`
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (
              response.data.responsecode == 200 &&
              response.data.data &&
              response.data.data.length
            ) {
              var fulladdress = response.data.data[0].address.split(",.");
              Object.assign(this.input, response.data.data[0]);
              this.input.address = fulladdress[0];
              this.input.amphoe = fulladdress[2];
              this.input.tambon = fulladdress[3];
              this.input.province = fulladdress[4];
              var name = "";
              if (response.data.data[0].name) {
                name = response.data.data[0].name.split(" ");
                this.input.firstname = name[0];
                this.input.lastname = name[1];
              }
              resolve();
            } else resolve();
          });
      });
    },
    checkLoginStatus() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toacheckstatuslogincustomer",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: {
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: this.query.pageid,
              },
            }
          )
          .then(async (response) => {
            if (response.data.responsecode == 400) {
              resolve();
            } else {
              await vm.$swal.fire({
                text: "คุณเข้าสู่ระบบเรียบร้อยแล้ว",
              });
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
            }
          });
      });
    },
    checkFeyvery() {
      var vm = this;
      return new Promise((resolve) => {
        vm.saveloading = true;
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toacheckusersfeyverly",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: {
                phoneno: vm.input.phoneno,
              },
            }
          )
          .then(async (response) => {
            vm.saveloading = false;
            if (response.data.responsecode == 200) {
              var name;
              if (this.query.dealer == "true") {
                name = this.input.storename;
              } else {
                name = this.input.firstname + " " + this.input.lastname;
              }
              var fulladdress = `${this.input.address},.${this.input.postcode},.อำเภอ${this.input.amphoe},.ตำบล${this.input.tambon},.จังหวัด${this.input.province}`;
              var data = {
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: this.query.pageid,
                name: name,
                email: vm.removeHiddenSpace(vm.input.email),
                photourl: this.input.photourl,
                address: fulladdress,
                address2: this.input.address2,
                postcode: this.input.postcode,
                experience: this.input.experience,
                contact_name: this.input.contact_name,
                phoneno: this.input.phoneno,
                fillgood_status: this.input.fillgood_status,
                paysolution_status: this.input.paysolution_status,
                toa_shopid: this.input.toa_shopid,
              };
              vm.$store.state.registerData = data;

              if (response.data.data[0].status) {
                // true
                vm.$store.state.registerType = "dealer";
                vm.query.view = "Login";
              } else {
                vm.$store.state.registerType = "dealer";
                vm.query.view = "OTP";
              }
            } else {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              resolve();
            }
          });
      });
    },

    gmapaddress(data) {
      Object.assign(this.input, data);
      this.gmapopen = false;
    },
    gmapScriptInit({ key }) {
      var vm = this;
      return new Promise((resolve) => {
        let externalScript = document.createElement("script");
        externalScript.setAttribute(
          "src",
          `https://maps.googleapis.com/maps/api/js?key=${key}&language=th&libraries=places`
        );
        externalScript.async = true;
        externalScript.defer = true;
        externalScript.onload = () => {
          vm.showmap = true;
          resolve();
        };
        document.head.appendChild(externalScript);
      });
    },
    onSelectAddress(address) {
      this.input.amphoe = address.amphoe;
      this.input.tambon = address.district;
      this.input.province = address.province;
      this.input.postcode = address.zipcode;
    },
    register() {
      if (!this.saveloading) {
        var vm = this;
        this.saveloading = true;
        var name;
        if (this.query.dealer == "true") {
          name = this.input.storename;
        } else {
          name = this.input.firstname + " " + this.input.lastname;
        }
        var fulladdress = `${this.input.address},.${this.input.postcode},.อำเภอ${this.input.amphoe},.ตำบล${this.input.tambon},.จังหวัด${this.input.province}`;
        var data = {
          userid: this.$store.state.userid,
          apptype: this.query.apptype,
          pageid: this.query.pageid,
          name: name,
          photourl: this.input.photourl,
          address: fulladdress,
          address2: this.input.address2,
          postcode: this.input.postcode,
          experience: this.input.experience,
          contact_name: this.input.contact_name,
          phoneno: this.input.phoneno,
          fillgood_status: this.input.fillgood_status,
          paysolution_status: this.input.paysolution_status,
          toa_shopid: this.input.toa_shopid,
        };
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/toaregister",
            data,
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            this.saveloading = false;
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (response.data.responsecode == 200) {
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
            } else if (response.data.responsecode == 401) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              vm.query.view = "Login";
            } else {
              vm.$swal.fire({
                icon: "error",
                text: "ลงทะเบียนไม่สำเร็จ",
              });
            }
          });
      }
    },
  },
};
</script>
